import { Product } from './product';

export enum ClickoutSegment {
  WISHLIST = 'wishlist',
  SEARCH = 'search',
  CATEGORY = 'category',
  CONTENT = 'content',
  RECOMMENDATION = 'reco',
  DY_RECOMMENDATION = 'dyreco',
}

export interface ClickoutProps {
  sorted?: boolean;
  index: number;
  product: Product;
  area?: ClickoutArea;
  trackingToken?: string;
}

export enum ClickoutArea {
  OTHER = 'other', // for all other except below
  PRODUCT_TILE_IMAGE = 'product_tile_image', //for product tile top
  PRODUCT_DETAILS_IMAGE = 'product_details_image', //for sea
  PRODUCT_DETAILS_CTA = 'product_details_cta', //for sea button
  QUICKLIST_ORIGIN = 'quicklist_origin', // first item in quicklist
  QUICKLIST_RECOMMENDED = 'quicklist_recommended', // all other items in quicklist
  MAGNIFYING_GLASS = 'magnifying_glass', // Magnifying glass within the tile
}
